var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletmain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 299.56 239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b7cdda93-431d-4612-947d-9ebb2011710b{fill:none;}.bd200eb6-87a1-4db4-a9ad-6650666c6cd4{isolation:isolate;}.a7156ec6-13b2-4888-afb4-50c34d8285a3{fill:#f2f2f2;}.aa9b9fe9-4c26-4cd9-9e09-d2e4b072b72e{fill:#27b69b;}.f64ed231-3843-4a15-8086-87957d07b1b3{fill:#2b343a;}.ae024bb2-9578-40fb-a8bf-0b0b5d702e47{fill:#ff5249;}.f508233b-e438-4070-955a-1a2df3951e08{fill:#0a4356;}.f1d93956-8d9f-470a-a02b-373eff0e882d{fill:#586f7d;}.affa60b3-3b60-4035-b4ab-5b435c539a26{fill:#ecf6f8;}.aa024c1c-0368-4a11-85d5-25ad0ef67e44{fill:#d1e4e2;}.aafa27cc-83ce-4c91-a40e-49a033f23578{fill:url(#ad172138-b341-4baa-906c-a18d72272086);}.f33d5718-e280-4378-a5ae-390120d37013{fill:#222126;}.b938a401-4fe2-4eb1-81ab-8a1cc351d1ab{clip-path:url(#e4e4ed99-e126-4d4c-a33f-f575d1ccd7bb);}.b9973262-7db1-4d7c-9cc2-f23d3ec9fe7d{fill:url(#fd141673-04d0-4d8b-ad45-fcd1a828fa7c);}.ec760a9d-f5f9-46e0-906b-9736d456dc5f{clip-path:url(#a446c4c9-d75a-4899-9ab4-12c9fd758564);}.a6c2efdc-4fbd-4d10-ba0b-39de92cb2a33{fill:url(#eaca27db-6c8e-4b02-a065-70f878f1f55f);}.f551289c-c341-4299-b25e-4753c52bacbd{fill:url(#a956a4a7-ca62-4d76-91de-33c68852b8e4);}.a8e485ef-318f-4279-b972-740b9647ee9d{fill:url(#bc237764-bca5-4757-ae27-c36afee39116);}.a78c85f7-a9ce-4b6a-acc7-72956e674087{fill:url(#fc6439b9-c0cc-4874-aefc-8bf242965dde);}.bfe71730-00bd-44a2-827e-22bbad6df60a{fill:#fff;}.ad9787e6-1708-4a8a-a8e9-ab4a1351e793{fill:#f6f6f6;}.e5c0447a-0261-46e1-9a67-fd3bb3c8ef4e{fill:#2e3338;}.f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e{fill:#e6e6e6;}.a8786b27-4c6f-4dfa-84ef-8c2cf75e6cbc{fill:url(#f92f9297-a17b-43d7-bf4d-997bf355bd8c);}.b322debc-af28-47b7-b876-baf8129f8604{fill:#f1f2f2;}.a0d730f2-1e34-4844-8032-349d599f11b6{fill:url(#be6ffc0d-a07a-48c5-bd78-70e207cc7442);}.ac6a40e9-d8c8-44ff-83b8-df1c5c91c63f{fill:url(#bdf80f2d-5dd2-410f-970e-069a015bdbba);}.b098b197-8703-41db-bdba-2107eb9e85ab{fill:url(#fef0095b-ad8d-4a0a-8cf3-cf39c8e14a47);}.a124375d-9abd-45ec-93f2-2e43e3336fa4{mix-blend-mode:multiply;}.bfa8ebfc-2264-4d45-993f-a0b404b4b581{fill:#b3b3b1;}.a7c8333f-65c8-4666-bf28-c129d5f7d826{fill:#63c8d4;}.ff6b2932-35e9-42cd-8541-120acfcd4074{fill:#3fa9f5;}.f6cd8a6e-7cec-4249-a2af-0093bf6ca6b3{fill:#e4e7e7;}.a1ef63c5-d6f9-458e-969f-9d1600c84b40{fill:#868686;}.b3f17d14-15fe-407c-83e9-579658dd5b95{fill:#b7bbbd;}.a3728e80-552a-413e-b645-261748f8bc82{fill:url(#bcb48698-576d-4b93-954e-cfe6fba59e15);}.b0d905e9-e1cf-4e50-bca9-220a7a36271f{fill:#0065ff;}.b8856252-7317-47f1-bb68-ebc4ccf88951{fill:url(#ab860b77-6bb1-4d86-bb09-0be13af8aa5b);}.ea3c68ad-b330-444c-996f-609fdf648ef8{fill:#f5c31c;}.b4912eb8-cfe8-4f21-aaab-9caa77c33b63{fill:#f7971d;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad172138-b341-4baa-906c-a18d72272086",
    x1: 3245.59,
    y1: -94.64,
    x2: 3245.59,
    y2: -95.19,
    gradientTransform: "matrix(1, 0, 0, -1, -2975.29, 260.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e4e4ed99-e126-4d4c-a33f-f575d1ccd7bb",
    transform: "translate(-105 -151)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b7cdda93-431d-4612-947d-9ebb2011710b",
    d: "M270.29,353.12v1.77a.17.17,0,0,0,.17.17h29.06c.49,0,.91,0,1.28-.05.22,0,.39-.05.57-.08l.07,0a1.19,1.19,0,0,0,.64-1.08.18.18,0,0,0-.17-.17L270.47,353A.18.18,0,0,0,270.29,353.12Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd141673-04d0-4d8b-ad45-fcd1a828fa7c",
    x1: -2060.07,
    y1: 125.94,
    x2: -2057.56,
    y2: 125.94,
    gradientTransform: "translate(-1863 329) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8a7ad",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a8a7ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a8a7ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8a7ad",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a446c4c9-d75a-4899-9ab4-12c9fd758564",
    transform: "translate(-105 -151)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b7cdda93-431d-4612-947d-9ebb2011710b",
    d: "M270.29,353.12v1.77a.16.16,0,0,1-.17.17H241.06c-.48,0-.91,0-1.28-.05-.22,0-.39-.05-.57-.08l-.06,0a1.15,1.15,0,0,1-.64-1.08.17.17,0,0,1,.17-.17l31.44-.71A.18.18,0,0,1,270.29,353.12Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eaca27db-6c8e-4b02-a065-70f878f1f55f",
    x1: -1981.48,
    y1: 125.94,
    x2: -1978.98,
    y2: 125.94,
    gradientTransform: "matrix(1, 0, 0, -1, 2115, 329)",
    xlinkHref: "#fd141673-04d0-4d8b-ad45-fcd1a828fa7c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a956a4a7-ca62-4d76-91de-33c68852b8e4",
    x1: 875.2,
    y1: 152.36,
    x2: 875.2,
    y2: 125.56,
    gradientTransform: "matrix(1, 0, 0, -1, -604.91, 480)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19181d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#242328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1e1d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2c2b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2e2d32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e2d32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc237764-bca5-4757-ae27-c36afee39116",
    x1: 185.18,
    y1: 185.62,
    x2: 362.63,
    y2: 185.62,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 502)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#201f24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc6439b9-c0cc-4874-aefc-8bf242965dde",
    x1: 505.94,
    y1: 234.8,
    x2: 714.14,
    y2: 234.8,
    gradientTransform: "matrix(1, 0, 0, -1, -339.72, 480)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0a0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f92f9297-a17b-43d7-bf4d-997bf355bd8c",
    x1: 186.59,
    y1: 685.8,
    x2: 192.84,
    y2: 690.69,
    gradientTransform: "translate(0 -482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ebebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dcdedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#caccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b4b6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be6ffc0d-a07a-48c5-bd78-70e207cc7442",
    x1: 187.94,
    y1: 687.37,
    x2: 185.13,
    y2: 687.37,
    gradientTransform: "translate(-105 -633)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ebebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#dcdedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#caccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b4b6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdf80f2d-5dd2-410f-970e-069a015bdbba",
    x1: 185.98,
    y1: 692.64,
    x2: 188.3,
    y2: 694.14,
    gradientTransform: "translate(-105 -633)",
    xlinkHref: "#f92f9297-a17b-43d7-bf4d-997bf355bd8c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fef0095b-ad8d-4a0a-8cf3-cf39c8e14a47",
    x1: 186.51,
    y1: 693.02,
    x2: 185.22,
    y2: 690.86,
    gradientTransform: "translate(-105 -633)",
    xlinkHref: "#f92f9297-a17b-43d7-bf4d-997bf355bd8c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bcb48698-576d-4b93-954e-cfe6fba59e15",
    x1: 141.73,
    y1: 300.44,
    x2: 190.77,
    y2: 300.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0061f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0058dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0052cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab860b77-6bb1-4d86-bb09-0be13af8aa5b",
    x1: 188.88,
    y1: 297.5,
    x2: 202.09,
    y2: 297.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0061f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0058dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0052cd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bd200eb6-87a1-4db4-a9ad-6650666c6cd4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b7cf9d4e-2854-4df5-8f76-c488f6c6b8a3",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a7156ec6-13b2-4888-afb4-50c34d8285a3",
    d: "M228.4,335.11s-129.19,4.54-123.2,14.1,36.44,16,29.38,26.62,112.23,23.47,114.91,4.27,106.27,2.14,92.61-12.8,20.34-13.85,4.68-20.26S228.4,335.11,228.4,335.11Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aa9b9fe9-4c26-4cd9-9e09-d2e4b072b72e",
    x: 94.58,
    y: 123.35,
    width: 33.44,
    height: 14.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f64ed231-3843-4a15-8086-87957d07b1b3",
    x: 132.24,
    y: 123.35,
    width: 33.11,
    height: 14.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ae024bb2-9578-40fb-a8bf-0b0b5d702e47",
    x: 169.36,
    y: 123.35,
    width: 33.32,
    height: 14.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f508233b-e438-4070-955a-1a2df3951e08",
    x: 205.81,
    y: 123.35,
    width: 32.99,
    height: 14.49
  })), /*#__PURE__*/React.createElement("g", {
    id: "f638e8f1-7253-44ef-9383-2da7f323ffd7",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f1d93956-8d9f-470a-a02b-373eff0e882d",
    d: "M382.37,241l.06,0c.39-.16.78-.34,1.16-.52a.21.21,0,0,0,.11-.28.23.23,0,0,0-.3-.11c-.37.18-.76.35-1.13.51l-.07,0a.21.21,0,0,0-.12.28A.23.23,0,0,0,382.37,241Zm-1.23.49a.22.22,0,0,0,.12-.28.21.21,0,0,0-.28-.12l-1.24.44a.22.22,0,0,0-.15.27.22.22,0,0,0,.28.14q.63-.21,1.26-.45Zm3.63-1.62h0l1.17-.63a.23.23,0,0,0,.09-.3.23.23,0,0,0-.3-.08l-1.16.62a.23.23,0,0,0-.1.3A.21.21,0,0,0,384.77,239.91Zm2.31-1.29,0,0c.38-.23.76-.47,1.13-.72a.21.21,0,1,0-.24-.35l-1.12.7a.22.22,0,0,0,.2.39Zm2.21-1.47,0,0,1.07-.8a.22.22,0,0,0,0-.3.23.23,0,0,0-.31,0l-1.06.79a.21.21,0,0,0-.05.3A.22.22,0,0,0,389.29,237.15Zm2.1-1.61.06,0c.34-.28.68-.57,1-.87a.21.21,0,0,0,0-.3.22.22,0,0,0-.31,0c-.32.29-.66.58-1,.86a.21.21,0,0,0,0,.31A.23.23,0,0,0,391.39,235.54Zm2-1.77.06,0c.32-.31.64-.62.95-.94a.22.22,0,1,0-.32-.3c-.3.32-.62.63-.93.93a.22.22,0,0,0,0,.31A.23.23,0,0,0,393.37,233.77Zm1.84-1.89.08-.06.87-1a.21.21,0,0,0,0-.31.23.23,0,0,0-.31,0c-.28.33-.57.67-.86,1a.22.22,0,0,0,0,.31A.21.21,0,0,0,395.21,231.88Zm1.7-2a.28.28,0,0,0,.09-.07c.27-.34.53-.7.79-1.06a.21.21,0,0,0,0-.3.22.22,0,0,0-.31.05c-.26.36-.52.71-.79,1.05a.22.22,0,0,0,0,.31A.24.24,0,0,0,396.91,229.85Zm1.55-2.14a.17.17,0,0,0,.09-.08c.25-.37.49-.74.72-1.12a.21.21,0,0,0-.07-.29.22.22,0,0,0-.3.07c-.23.37-.47.74-.71,1.11a.21.21,0,0,0,.06.3A.22.22,0,0,0,398.46,227.71Zm1.38-2.24a.26.26,0,0,0,.11-.1v0c.21-.37.42-.75.61-1.13a.22.22,0,0,0-.09-.3.24.24,0,0,0-.3.1c-.19.38-.39.76-.6,1.12l0,0a.21.21,0,0,0,.09.29A.25.25,0,0,0,399.84,225.47Zm1.2-2.34a.28.28,0,0,0,.12-.12c.18-.39.36-.8.53-1.2a.22.22,0,0,0-.12-.29.22.22,0,0,0-.28.12c-.17.41-.35.81-.53,1.2a.2.2,0,0,0,.1.28A.23.23,0,0,0,401,223.13Zm1-2.43a.2.2,0,0,0,.12-.12c.15-.41.3-.83.44-1.25a.21.21,0,0,0-.14-.27.23.23,0,0,0-.27.14c-.14.41-.29.83-.44,1.23a.21.21,0,0,0,.13.28A.18.18,0,0,0,402.06,220.7Zm.84-2.48a.28.28,0,0,0,.12-.14c.13-.42.25-.85.36-1.27a.22.22,0,0,0-.16-.27.23.23,0,0,0-.27.16c-.11.42-.23.85-.35,1.26a.22.22,0,0,0,.15.27A.26.26,0,0,0,402.9,218.22Zm.65-2.54a.2.2,0,0,0,.13-.16c.1-.42.19-.86.27-1.29a.22.22,0,0,0-.43-.07c-.08.42-.17.85-.26,1.28a.2.2,0,0,0,.16.25A.19.19,0,0,0,403.55,215.68Zm.48-2.58a.24.24,0,0,0,.14-.17c.06-.43.12-.87.17-1.3a.22.22,0,0,0-.2-.24.22.22,0,0,0-.24.19c0,.43-.1.86-.17,1.29a.22.22,0,0,0,.19.25A.2.2,0,0,0,404,213.1Zm.3-2.6a.21.21,0,0,0,.13-.19c0-.43.06-.87.08-1.31a.21.21,0,0,0-.21-.22.22.22,0,0,0-.23.21c0,.43,0,.87-.08,1.3a.22.22,0,0,0,.21.23Zm.1-2.61a.23.23,0,0,0,.13-.21c0-.44,0-.88,0-1.31a.22.22,0,0,0-.23-.21.23.23,0,0,0-.21.23c0,.43,0,.86,0,1.3a.21.21,0,0,0,.21.21Zm-.1-2.62a.22.22,0,0,0,.14-.22c0-.43-.08-.87-.13-1.31a.22.22,0,0,0-.25-.18.22.22,0,0,0-.19.24c.05.43.09.86.13,1.29a.21.21,0,0,0,.23.2Zm-.31-2.59a.22.22,0,0,0,.13-.24c-.07-.43-.15-.87-.24-1.29a.22.22,0,0,0-.26-.17.22.22,0,0,0-.17.26c.09.42.17.85.24,1.28a.22.22,0,0,0,.25.17Zm-.54-2.56a.21.21,0,0,0,.13-.25c-.11-.43-.23-.85-.36-1.27a.23.23,0,0,0-.28-.14.22.22,0,0,0-.14.27c.13.41.25.83.35,1.25a.21.21,0,0,0,.27.15Zm-.78-2.49a.21.21,0,0,0,.12-.27q-.19-.54-.42-1.08l-.07-.14a.22.22,0,0,0-.28-.12h0a.22.22,0,0,0-.12.29l.06.14c.15.35.29.71.42,1.06a.22.22,0,0,0,.28.13Zm-13,3.45a.21.21,0,0,0,.12-.27.22.22,0,0,0-.28-.13,10.42,10.42,0,0,1-1.24.37.23.23,0,0,0-.17.27.23.23,0,0,0,.26.16c.44-.11.88-.24,1.3-.39Zm1.21-.53h0a12.31,12.31,0,0,0,1.16-.7.22.22,0,1,0-.25-.35,10.15,10.15,0,0,1-1.11.66.22.22,0,0,0-.1.29A.21.21,0,0,0,390.92,200.55Zm-3.78,1.14a.21.21,0,0,0,.13-.22.21.21,0,0,0-.24-.19c-.43.05-.87.07-1.3.08a.21.21,0,0,0-.22.21.22.22,0,0,0,.22.22,11.9,11.9,0,0,0,1.34-.08Zm6-2.62.06,0c.34-.29.67-.6,1-.92a.22.22,0,0,0,0-.31.23.23,0,0,0-.31,0,10.08,10.08,0,0,1-.95.89.22.22,0,0,0,0,.31A.23.23,0,0,0,393.11,199.07Zm8.56-3.83h0a.22.22,0,0,0,.1-.29c-.2-.39-.41-.78-.62-1.16a.21.21,0,0,0-.3-.07.21.21,0,0,0-.09.29c.22.37.42.75.61,1.14A.23.23,0,0,0,401.67,195.24Zm-17.18,6.46a.22.22,0,0,0,.14-.18.23.23,0,0,0-.19-.24,9.26,9.26,0,0,1-1.28-.22.23.23,0,0,0-.26.16.22.22,0,0,0,.16.27,11.72,11.72,0,0,0,1.32.22A.2.2,0,0,0,384.49,201.7Zm10.43-4.55a.16.16,0,0,0,.09-.07,9.14,9.14,0,0,0,.74-1.13.21.21,0,0,0-.08-.29.22.22,0,0,0-.3.09,9.45,9.45,0,0,1-.71,1.07.22.22,0,0,0,.26.33Zm-13,3.94a.23.23,0,0,0,.12-.12.22.22,0,0,0-.13-.28,9.45,9.45,0,0,1-1.17-.52.22.22,0,0,0-.3.09.21.21,0,0,0,.09.29,10.32,10.32,0,0,0,1.22.55A.2.2,0,0,0,381.94,201.09Zm14.28-6.22a.34.34,0,0,0,.12-.12,11.27,11.27,0,0,0,.42-1.28.21.21,0,0,0-.16-.26.23.23,0,0,0-.27.16,9.15,9.15,0,0,1-.4,1.22.21.21,0,0,0,.12.28A.25.25,0,0,0,396.22,194.87Zm4.15-1.89,0,0a.22.22,0,0,0,.07-.3c-.25-.36-.5-.73-.76-1.07a.22.22,0,0,0-.36.26q.39.51.75,1.05A.22.22,0,0,0,400.37,193Zm-20.74,6.89a.32.32,0,0,0,.09-.08.21.21,0,0,0-.05-.3,9.55,9.55,0,0,1-1-.82.22.22,0,1,0-.31.31,8.43,8.43,0,0,0,1,.86A.25.25,0,0,0,379.63,199.87Zm17.26-7.53a.23.23,0,0,0,.13-.18,11.38,11.38,0,0,0,.1-1.32.21.21,0,0,0-.21-.22.23.23,0,0,0-.23.21,10.54,10.54,0,0,1-.1,1.28.22.22,0,0,0,.19.24A.25.25,0,0,0,396.89,192.34Zm1.91-1.44.06,0a.21.21,0,0,0,0-.3c-.28-.34-.58-.66-.89-1a.23.23,0,0,0-.31,0,.22.22,0,0,0,0,.31c.29.3.59.62.87,1A.23.23,0,0,0,398.8,190.9Zm-21,7.13,0,0a.21.21,0,0,0,.05-.3,7,7,0,0,1-.66-1.09.23.23,0,0,0-.3-.09.21.21,0,0,0-.09.29,7.68,7.68,0,0,0,.69,1.14A.22.22,0,0,0,377.78,198Zm19.17-8.3a.23.23,0,0,0,.14-.22L397,189h0a.21.21,0,0,0,0-.31l-.05,0c0-.14-.05-.28-.07-.42a.22.22,0,0,0-.25-.18.24.24,0,0,0-.18.17l-.46-.37a.22.22,0,0,0-.31,0,.23.23,0,0,0,0,.31c.28.22.56.45.82.68,0,.24.06.48.08.71a.21.21,0,0,0,.23.2Zm-20.35,6a.22.22,0,0,0,.12-.27,8.31,8.31,0,0,1-.3-1.24.23.23,0,0,0-.26-.17.22.22,0,0,0-.18.25,9.16,9.16,0,0,0,.33,1.3.21.21,0,0,0,.27.13Zm19.91-8.56a.21.21,0,0,0,.13-.25c-.11-.42-.23-.85-.38-1.27a.22.22,0,0,0-.28-.13.21.21,0,0,0-.13.27c.14.42.26.83.37,1.24a.21.21,0,0,0,.26.15Zm-1.59.25a.23.23,0,0,0,.1-.07A.22.22,0,0,0,395,187c-.36-.24-.73-.48-1.11-.71a.22.22,0,0,0-.3.07.21.21,0,0,0,.07.3c.37.22.74.46,1.09.7A.2.2,0,0,0,394.92,187.41Zm-18.77,5.75a.23.23,0,0,0,.13-.21,9.08,9.08,0,0,1,0-1.28.22.22,0,0,0-.2-.24.23.23,0,0,0-.24.2,12,12,0,0,0,0,1.34.21.21,0,0,0,.23.2Zm16.52-7.09a.18.18,0,0,0,.11-.1.2.2,0,0,0-.09-.29q-.58-.3-1.2-.57a.22.22,0,0,0-.29.11.21.21,0,0,0,.11.28c.4.18.79.37,1.17.56A.25.25,0,0,0,392.67,186.07Zm3-1.38a.22.22,0,0,0,.12-.28l-.06-.14c-.15-.35-.31-.71-.49-1.06a.22.22,0,0,0-.29-.1.22.22,0,0,0-.1.29c.17.35.33.7.47,1l.06.13a.22.22,0,0,0,.29.11Zm-5.41.32a.23.23,0,0,0,.12-.12.21.21,0,0,0-.13-.28c-.41-.15-.83-.3-1.25-.43a.22.22,0,0,0-.28.14.21.21,0,0,0,.14.27q.63.19,1.23.42A.25.25,0,0,0,390.27,185Zm-13.88,5.55a.2.2,0,0,0,.13-.15,9.77,9.77,0,0,1,.38-1.23.21.21,0,0,0-.13-.28.22.22,0,0,0-.28.13,9,9,0,0,0-.39,1.28.21.21,0,0,0,.16.26A.19.19,0,0,0,376.39,190.56Zm18.14-8.21h0a.21.21,0,0,0,.09-.29c-.21-.38-.44-.76-.68-1.13a.22.22,0,0,0-.3-.07.22.22,0,0,0-.07.3c.23.37.46.74.67,1.11A.2.2,0,0,0,394.53,182.35Zm-6.78,1.9a.26.26,0,0,0,.13-.16.22.22,0,0,0-.16-.26c-.44-.09-.89-.16-1.33-.21a.22.22,0,0,0-.24.19.21.21,0,0,0,.19.24c.42,0,.85.12,1.28.21A.29.29,0,0,0,387.75,184.25Zm-10.41,3.87a.21.21,0,0,0,.11-.1,8.59,8.59,0,0,1,.72-1.06.21.21,0,0,0,0-.3.22.22,0,0,0-.31,0,8.48,8.48,0,0,0-.76,1.12.21.21,0,0,0,.08.3A.25.25,0,0,0,377.34,188.12Zm7.79-4.16a.21.21,0,0,0,.13-.2.2.2,0,0,0-.21-.21,10,10,0,0,0-1.35.08.21.21,0,0,0-.19.24.22.22,0,0,0,.24.19A10.9,10.9,0,0,1,385,184Zm8-3.81,0,0a.21.21,0,0,0,.05-.3c-.25-.36-.52-.71-.79-1.05a.22.22,0,0,0-.35.27c.27.34.53.68.78,1A.22.22,0,0,0,393.13,180.15ZM379,186.07l.06,0a8.4,8.4,0,0,1,.9-.67l.13-.08a.22.22,0,0,0,.08-.3.21.21,0,0,0-.3-.07l-.14.08a7.51,7.51,0,0,0-1,.72.22.22,0,0,0,0,.31A.21.21,0,0,0,379,186.07Zm3.51-1.79a.22.22,0,0,0,.12-.25.21.21,0,0,0-.26-.16,9.29,9.29,0,0,0-1.29.43h0a.21.21,0,0,0-.12.28.22.22,0,0,0,.28.12,8.87,8.87,0,0,1,1.23-.41Zm9-6.17.06,0a.22.22,0,0,0,0-.31q-.43-.5-.9-1a.21.21,0,0,0-.31,0,.2.2,0,0,0,0,.3c.29.31.59.62.88.95A.21.21,0,0,0,391.5,178.11Zm-1.84-1.85a.24.24,0,0,0,.08-.06.21.21,0,0,0,0-.3c-.32-.3-.65-.59-1-.87a.22.22,0,0,0-.31,0,.21.21,0,0,0,0,.31l1,.86A.22.22,0,0,0,389.66,176.26Zm-2-1.71a.16.16,0,0,0,.08-.06.21.21,0,0,0,0-.31c-.33-.27-.68-.54-1-.81a.23.23,0,0,0-.31,0,.22.22,0,0,0,0,.31c.35.26.69.53,1,.8A.24.24,0,0,0,387.68,174.55ZM385.6,173a.32.32,0,0,0,.09-.08.21.21,0,0,0-.05-.3c-.35-.25-.71-.51-1.07-.75a.22.22,0,0,0-.31,0,.21.21,0,0,0,.05.3l1.07.75A.25.25,0,0,0,385.6,173Zm-2.17-1.48a.2.2,0,0,0,.1-.08.21.21,0,0,0-.06-.3c-.36-.24-.74-.47-1.11-.7a.22.22,0,1,0-.24.37l1.11.69A.21.21,0,0,0,383.43,171.49Zm-2.23-1.37a.22.22,0,0,0,0-.39l-1.15-.65a.22.22,0,0,0-.3.09.21.21,0,0,0,.09.29l1.13.65A.28.28,0,0,0,381.2,170.12Zm-2.29-1.27a.26.26,0,0,0,.11-.1.22.22,0,0,0-.09-.29q-.58-.32-1.17-.6a.23.23,0,0,0-.3.09.22.22,0,0,0,.1.29l1.16.6A.25.25,0,0,0,378.91,168.85Zm-2.35-1.18a.23.23,0,0,0,.12-.1.22.22,0,0,0-.1-.29l-1.19-.56a.23.23,0,0,0-.3.11.22.22,0,0,0,.11.29l1.18.55A.19.19,0,0,0,376.56,167.67Zm-2.38-1.09a.2.2,0,0,0,.11-.11.21.21,0,0,0-.11-.28l-1.21-.52a.23.23,0,0,0-.29.12.21.21,0,0,0,.12.28l1.2.51A.19.19,0,0,0,374.18,166.58Zm-2.43-1a.23.23,0,0,0,.12-.12.22.22,0,0,0-.12-.28l-1.23-.48a.24.24,0,0,0-.29.13.22.22,0,0,0,.13.28l1.22.47A.25.25,0,0,0,371.75,165.58Zm-2.46-.93a.2.2,0,0,0,.12-.12.22.22,0,0,0-.13-.28l-1.25-.44a.24.24,0,0,0-.28.14.21.21,0,0,0,.14.27l1.24.44A.22.22,0,0,0,369.29,164.65Zm-2.5-.85a.21.21,0,0,0,.13-.13.21.21,0,0,0-.14-.27l-1.26-.4a.23.23,0,0,0-.28.14.21.21,0,0,0,.15.27l1.25.4A.19.19,0,0,0,366.79,163.8Zm-2.52-.77a.25.25,0,0,0,.13-.14.21.21,0,0,0-.15-.27c-.42-.13-.84-.25-1.27-.36a.21.21,0,0,0-.27.15.21.21,0,0,0,.15.26l1.27.36A.22.22,0,0,0,364.27,163Zm-2.54-.71a.25.25,0,0,0,.13-.14.22.22,0,0,0-.15-.27l-1.29-.33a.22.22,0,0,0-.27.16.21.21,0,0,0,.16.26l1.28.33A.22.22,0,0,0,361.73,162.32Zm-2.56-.64a.22.22,0,0,0,.13-.15.21.21,0,0,0-.16-.26l-1.29-.29a.21.21,0,0,0-.26.16.21.21,0,0,0,.16.26l1.28.29A.17.17,0,0,0,359.17,161.68Zm-2.58-.57a.18.18,0,0,0,.13-.15.22.22,0,0,0-.16-.26l-1.3-.26a.23.23,0,0,0-.26.17.22.22,0,0,0,.17.26l1.29.26A.19.19,0,0,0,356.59,161.11Zm-2.59-.5a.18.18,0,0,0,.13-.16.21.21,0,0,0-.17-.25l-1.3-.22a.23.23,0,0,0-.26.17.22.22,0,0,0,.18.25l1.3.23A.17.17,0,0,0,354,160.61Zm-2.6-.43a.21.21,0,0,0,.13-.17.21.21,0,0,0-.18-.24l-1.31-.2a.23.23,0,0,0-.25.19.2.2,0,0,0,.18.24l1.31.2A.25.25,0,0,0,351.4,160.18Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "affa60b3-3b60-4035-b4ab-5b435c539a26",
    points: "216.63 11.38 239.94 9.01 239.07 0 216.63 11.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa024c1c-0368-4a11-85d5-25ad0ef67e44",
    d: "M349.31,159.67c-.3-.06-27.71,2.72-27.71,2.72l24.17,1.38Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "affa60b3-3b60-4035-b4ab-5b435c539a26",
    points: "216.63 11.38 240.88 19.02 240.77 12.77 216.63 11.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aafa27cc-83ce-4c91-a40e-49a033f23578",
    d: "M240.91,354a7.85,7.85,0,0,0-1.38.74.17.17,0,0,0,0,.31,13.24,13.24,0,0,0,4.3.38h52.88a13.17,13.17,0,0,0,4.3-.38.17.17,0,0,0,0-.31,7.85,7.85,0,0,0-1.39-.74c-.37,0-3.49.59-3.61.6l-26.74-.43a.17.17,0,0,0-.12.3h0a.17.17,0,0,1-.12.3l-24.56-.17c-.12,0-3.24-.57-3.61-.6Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f33d5718-e280-4378-a5ae-390120d37013",
    d: "M270.77,352.41l-32.1,1.25a.17.17,0,0,0-.16.17,1.15,1.15,0,0,0,.64,1.08l.06,0c.18,0,.35.06.57.08.37,0,.8.05,1.28.05h58.46c.49,0,.91,0,1.28-.05.22,0,.39-.05.57-.08l.07,0a1.19,1.19,0,0,0,.64-1.08.18.18,0,0,0-.17-.17L271.08,353a.18.18,0,0,1-.17-.22l0-.13A.17.17,0,0,0,270.77,352.41Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b938a401-4fe2-4eb1-81ab-8a1cc351d1ab"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b9973262-7db1-4d7c-9cc2-f23d3ec9fe7d",
    x: 188.78,
    y: 200.95,
    width: 8.29,
    height: 4.22
  })), /*#__PURE__*/React.createElement("g", {
    className: "ec760a9d-f5f9-46e0-906b-9736d456dc5f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a6c2efdc-4fbd-4d10-ba0b-39de92cb2a33",
    x: 133.52,
    y: 200.95,
    width: 8.29,
    height: 4.22
  })), /*#__PURE__*/React.createElement("path", {
    className: "f551289c-c341-4299-b25e-4753c52bacbd",
    d: "M270.29,321.43l-20.78.65a.16.16,0,0,0-.16.18,125.39,125.39,0,0,1-1.29,19.14c-.18,1.33-.36,2.78-.66,4.19a6,6,0,0,1-2,3.39,19.64,19.64,0,0,1-2.7,1.56,22.45,22.45,0,0,0-3.23,2.1,5.14,5.14,0,0,0-.92.89.27.27,0,0,0,0,.16c0,.2.27.31.51.4a16.15,16.15,0,0,0,3.94.35c.93,0,2.06,0,3.09,0h48.46c1,0,2.16,0,3.1,0a16.15,16.15,0,0,0,3.94-.35c.24-.09.51-.2.51-.4a.37.37,0,0,0-.05-.16,5.14,5.14,0,0,0-.92-.89,23.23,23.23,0,0,0-3.24-2.1,18.94,18.94,0,0,1-2.69-1.56,5.91,5.91,0,0,1-2-3.39c-.31-1.41-.48-2.86-.67-4.19a125.37,125.37,0,0,1-1.28-19.14.17.17,0,0,0-.17-.18l-20.77-.65Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.36,307.1a.18.18,0,0,0-.17.17v12c0,5.43,2.1,6.9,6.9,6.9h194.4c4.8,0,6.9-1.47,6.9-6.9v-12a.17.17,0,0,0-.17-.17Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8e485ef-318f-4279-b972-740b9647ee9d",
    d: "M166.36,306.84a.18.18,0,0,0-.17.17v12c0,5.43,2.1,6.9,6.91,6.9H367.55c4.81,0,6.91-1.47,6.91-6.9V307a.18.18,0,0,0-.18-.17Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a78c85f7-a9ce-4b6a-acc7-72956e674087",
    d: "M173.12,183.31c-4.8,0-6.9,1.46-6.9,6.9V306.93a.18.18,0,0,0,.18.17H374.25a.17.17,0,0,0,.17-.17V190.21c0-5.44-2.09-6.91-6.9-6.91H173.12Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.96,
    y: 40.54,
    width: 190.67,
    height: 107.32,
    rx: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "bfe71730-00bd-44a2-827e-22bbad6df60a",
    d: "M364.81,300.57V195.91s-188.24-1.27-189.52,0V300.57Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad9787e6-1708-4a8a-a8e9-ab4a1351e793",
    x: 102.7,
    y: 111.35,
    width: 28.56,
    height: 29.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e5c0447a-0261-46e1-9a67-fd3bb3c8ef4e",
    x: 263.07,
    y: 119.41,
    width: 15.19,
    height: 178.52,
    transform: "translate(-43 328.34) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 77.74,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 69.61,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 85.87,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 94,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 102.14,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 110.27,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 118.4,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 126.53,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 76.73,
    y: 134.67,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad9787e6-1708-4a8a-a8e9-ab4a1351e793",
    x: 135.03,
    y: 111.35,
    width: 28.56,
    height: 29.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad9787e6-1708-4a8a-a8e9-ab4a1351e793",
    x: 167.29,
    y: 111.35,
    width: 28.56,
    height: 29.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ad9787e6-1708-4a8a-a8e9-ab4a1351e793",
    x: 199.46,
    y: 111.35,
    width: 28.56,
    height: 29.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 234.56,
    y: 77.74,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 234.56,
    y: 69.61,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 234.56,
    y: 85.87,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 234.56,
    y: 94,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f41f49ac-0d7f-47f5-b8f0-b9235ed89c3e",
    x: 234.56,
    y: 102.14,
    width: 19.64,
    height: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8786b27-4c6f-4dfa-84ef-8c2cf75e6cbc",
    d: "M193.48,206.84v1l-1.33.54-4.23-1.75-2.69-1.11,2.69-1.49,4.55,1.63A1.47,1.47,0,0,1,193.48,206.84Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b322debc-af28-47b7-b876-baf8129f8604",
    d: "M187.71,210.11V213l0,0,4.75-2.09a1.59,1.59,0,0,0,1-1.22v-1.88l-1.38.54Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "a0d730f2-1e34-4844-8032-349d599f11b6",
    points: "82.93 53.07 82.93 55.67 80.13 54.55 82.93 53.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "ac6a40e9-d8c8-44ff-83b8-df1c5c91c63f",
    points: "82.71 59.12 82.71 62.06 80.23 60.8 82.71 59.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "b098b197-8703-41db-bdba-2107eb9e85ab",
    points: "80.23 60.8 80.23 57.85 82.71 59.12 80.23 60.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aa9b9fe9-4c26-4cd9-9e09-d2e4b072b72e",
    x: 102.92,
    y: 111,
    width: 28.37,
    height: 12.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f64ed231-3843-4a15-8086-87957d07b1b3",
    x: 134.92,
    y: 111,
    width: 28.37,
    height: 12.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ae024bb2-9578-40fb-a8bf-0b0b5d702e47",
    x: 167.65,
    y: 111,
    width: 28.37,
    height: 12.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f508233b-e438-4070-955a-1a2df3951e08",
    x: 199.65,
    y: 111,
    width: 28.37,
    height: 12.45
  }), /*#__PURE__*/React.createElement("g", {
    className: "a124375d-9abd-45ec-93f2-2e43e3336fa4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bfa8ebfc-2264-4d45-993f-a0b404b4b581",
    d: "M281.08,253.62c-21.63,0-21.63-13.37-43.25-13.37s-21.63,13.37-43.26,13.37Z",
    transform: "translate(-105 -151)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a124375d-9abd-45ec-93f2-2e43e3336fa4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa9b9fe9-4c26-4cd9-9e09-d2e4b072b72e",
    d: "M301.85,253.62c-21.63,0-21.63-15-43.26-15s-21.62,15-43.25,15Z",
    transform: "translate(-105 -151)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a124375d-9abd-45ec-93f2-2e43e3336fa4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae024bb2-9578-40fb-a8bf-0b0b5d702e47",
    d: "M324.78,253.62c-21.63,0-21.63-28.17-43.25-28.17s-21.63,28.17-43.26,28.17Z",
    transform: "translate(-105 -151)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a124375d-9abd-45ec-93f2-2e43e3336fa4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a7c8333f-65c8-4666-bf28-c129d5f7d826",
    d: "M346.63,253.62c-21.63,0-21.63-18.44-43.25-18.44s-21.63,18.44-43.26,18.44Z",
    transform: "translate(-105 -151)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "f99f834d-0d2d-4c92-ab45-d34964b1af32",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ff6b2932-35e9-42cd-8541-120acfcd4074",
    d: "M198.31,289.21v-9.95a3.57,3.57,0,0,0-3.77-3.32h-49a3.57,3.57,0,0,0-3.77,3.32v28.2a3.56,3.56,0,0,0,3.77,3.31h49a3.56,3.56,0,0,0,3.77-3.31v-10a3.57,3.57,0,0,0,3.78-3.31v-1.66A3.57,3.57,0,0,0,198.31,289.21Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f6cd8a6e-7cec-4249-a2af-0093bf6ca6b3",
    d: "M151.16,267.65h37.72a3.56,3.56,0,0,1,3.77,3.32v23.22a3.56,3.56,0,0,1-3.77,3.31H151.16a3.56,3.56,0,0,1-3.77-3.31V271A3.56,3.56,0,0,1,151.16,267.65Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a1ef63c5-d6f9-458e-969f-9d1600c84b40",
    d: "M159.2,276s2.29,0,4.45,0,2.55,3.2,2.55,3.2,0,3.34,0,4.17-1.86,2.46-1.86,2.46v1.68l5.66,2v3.09H153v-3.15l5.67-1.91v-1.65s-1.88-1.48-1.88-2.51v-4.17S157,276,159.2,276Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b3f17d14-15fe-407c-83e9-579658dd5b95",
    x: 66.91,
    y: 131.58,
    width: 13.2,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b3f17d14-15fe-407c-83e9-579658dd5b95",
    x: 66.91,
    y: 124.94,
    width: 13.2,
    height: 3.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "b3f17d14-15fe-407c-83e9-579658dd5b95",
    d: "M188.88,267.65H151.16a3.56,3.56,0,0,0-3.77,3.32v1.65h45.26V271A3.56,3.56,0,0,0,188.88,267.65Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3728e80-552a-413e-b645-261748f8bc82",
    d: "M145.5,282.19l41.5,5a3.56,3.56,0,0,1,3.77,3.31v28.2A3.57,3.57,0,0,1,187,322l-41.5-5a3.56,3.56,0,0,1-3.77-3.31V278.87A3.56,3.56,0,0,0,145.5,282.19Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b0d905e9-e1cf-4e50-bca9-220a7a36271f",
    d: "M182.28,297.5a2.51,2.51,0,1,1-2.83,2.49A2.68,2.68,0,0,1,182.28,297.5Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b0d905e9-e1cf-4e50-bca9-220a7a36271f",
    d: "M145.5,315.75l41.5,5a3.57,3.57,0,0,0,3.77-3.32v-6.64l-45.27-5a3.56,3.56,0,0,1-3.77-3.32v9.95A3.56,3.56,0,0,0,145.5,315.75Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b8856252-7317-47f1-bb68-ebc4ccf88951",
    d: "M192.65,295.85s9.44-1.73,9.44-3.32v5s-1.69,3.32-3.78,3.32l-5.66,1.66a3.34,3.34,0,1,1,0-6.63Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ea3c68ad-b330-444c-996f-609fdf648ef8",
    d: "M381.41,237.67c-9.63,3.51-15.55-2-15.9-2.35v0h0v0c-.35.34-6.27,5.86-15.9,2.35,0,0-5.32,24.6,15.9,36.45h0C386.73,262.27,381.41,237.67,381.41,237.67Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b4912eb8-cfe8-4f21-aaab-9caa77c33b63",
    d: "M379,240.25c-8.17,3-13.2-1.71-13.49-2v0h0v0c-.29.28-5.32,5-13.49,2,0,0-4.51,20.87,13.49,30.93h0C383.51,261.12,379,240.25,379,240.25Z",
    transform: "translate(-105 -151)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bfe71730-00bd-44a2-827e-22bbad6df60a",
    points: "259.35 107.52 253.69 101.86 255.62 99.93 259.35 103.65 265.41 97.45 267.34 99.39 259.35 107.52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletmain);
export default __webpack_public_path__ + "static/media/walletmain.6fdd02b5cca26dc20e22aa14eb54abff.svg";
export { ForwardRef as ReactComponent };